import * as THREE from 'three';
import { TUNING } from '../graphics-tuning.js';

/**
 * How vivid the land is. Every ground and scenery colour passes through `gradeLand`, so the whole outdoors can be pushed
 * toward a harder, greyer world (or back) from this one place instead of by editing hundreds of palette entries.
 * Lower `saturation` is less colourful; lower `lightness` is darker. 1 and 1 leave the authored palettes untouched.
 * The values live in `graphics-tuning.ts` and are read live, so the scenario viewer's land dials reach every colour built after they change.
 */
export const LAND_GRADE = { get saturation() { return TUNING.landSaturation; }, get lightness() { return TUNING.landLightness; } };

const hsl = { h: 0, s: 0, l: 0 };

/** Mutes `color` in place (in sRGB, where the palettes were authored). Pure white is the "use the geometry's own colours" marker and is left alone. */
export function gradeLand(color: THREE.Color): THREE.Color {
  if (color.r === 1 && color.g === 1 && color.b === 1) return color;
  color.getHSL(hsl, THREE.SRGBColorSpace);
  return color.setHSL(hsl.h, hsl.s * LAND_GRADE.saturation, hsl.l * LAND_GRADE.lightness, THREE.SRGBColorSpace);
}
